module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-251.770da481.svg";